<div class="authorization-filter">
  <div class="rkt-form authorization-select">
    <div class="rkt-form-control">
      <div class="rkt-form-field">
        <div class="rkt-form-select-field">
          @if (debitAuthEnabledForBusinessAccount$ | async) {
            <ng-select
              #select
              class="rkt-form-select rkt-form-select-assignee-dropdown"
              placeholder="Select Debit Authorization"
              [items]="(items$ | async) ?? []"
              [tabIndex]="0"
              [(ngModel)]="selectedItem"
              bindLabel="label"
              bindValue="value"
              [loading]="loading"
              [clearable]="true"
              [searchable]="false"
              (change)="onChange($event)"
              [closeOnSelect]="true"
              [minTermLength]="0"
              appendTo="body"
              [maxSelectedItems]="1"
              (open)="onOpen()"
              (close)="onClose()"
              [virtualScroll]="true"
              [notFoundText]="'No Debit Authorizations Found'"
            ></ng-select>
          } @else {
            <div class="ada-unavailable-message">OFFLINE DEBIT AUTHORIZATION</div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
